import axios from 'axios';

const BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://creativeglassworld.com/api'
  : 'http://localhost:9119/api';

const API = axios.create({ baseURL: BASE_URL });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 403 && err.response?.data?.message?.includes('deactivated')) {
      localStorage.removeItem('token');
      window.location.href = '/login?reason=deactivated';
    }
    return Promise.reject(err);
  }
);

export default API;
